import { inject, Injectable } from '@angular/core';
import { TableService } from '../../../../core/components/table/table.service';
import { AlertService } from '../../../../core/services/alert.service';
import { NetsuiteBom } from '../../../../api/netsuite/models/bom';
import { BomDetailsApiService } from '../bom-details.service';

@Injectable()
export class BomDetailsTableService extends TableService<NetsuiteBom> {
  protected readonly alertService = inject(AlertService);
  protected readonly apiRouter = inject(BomDetailsApiService);

  sortingItem = (
    a: NetsuiteBom,
    b: NetsuiteBom,
    nameOfSort: string,
    isAsc: boolean
  ): number => {
    const compareSorting = (
      first: number | string,
      second: number | string
    ): number => {
      return (first < second ? -1 : 1) * (isAsc ? 1 : -1);
    };
    switch (nameOfSort) {
      case 'item':
        return compareSorting(a.itemName, b.itemName);
      case 'description':
        return compareSorting(a.itemDescription, b.itemDescription);
      case 'quantity':
        return compareSorting(a.quantityPerAssembly, b.quantityPerAssembly);
      case 'onhand':
        return compareSorting(a.quantityOnHand, b.quantityOnHand);
      case 'unitType':
        return compareSorting(a.unitType, b.unitType);
      default:
        return 0;
    }
  };
}
